webpackJsonp([98148677116430],{

/***/ 725:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _config = __webpack_require__(8);
	
	var _FleetBreadcrum = __webpack_require__(31);
	
	var _FleetBreadcrum2 = _interopRequireDefault(_FleetBreadcrum);
	
	var _Fleet = __webpack_require__(20);
	
	var _Fleet2 = _interopRequireDefault(_Fleet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//Components
	var compact_pick_upEs = function compact_pick_upEs(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'page  Compact pick Up' },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: ' Compact pick Up Vehicles for Rent | Budget Nicaragua',
	      meta: [{
	        name: 'description',
	        content: 'Frequently Asked Questions about car rentals. '
	      }],
	      link: [{
	        rel: 'alternate',
	        hreflang: 'es',
	        href: './en/fleet/compact_pick_up'
	      }]
	    }),
	    _react2.default.createElement(_FleetBreadcrum2.default, {
	      lang: props.pathContext.langKey,
	      currentPage: ' Compact Pick Up Cars'
	    }),
	    _react2.default.createElement(
	      'h1',
	      null,
	      ' Compact Pick Up'
	    ),
	    _react2.default.createElement(_Fleet2.default, {
	      lang: props.pathContext.langKey,
	      types: props.data.dataJson.fleetTypes,
	      fleet: props.data.dataJson.fleet,
	      features: props.data.dataJson.fleetFeatures,
	      category: 12
	    })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = compact_pick_upEs;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-fleet-compact-pick-up-es-js-fc4734b8810a0886fea4.js